import { DataTablePFSEvent } from "primereact/datatable";
import { useEffect, useState } from "react";

type paramProps = { 
  total: number; 
  result: Record<string, unknown>[];
}
type paramInputProps = { 
  offset: number; 
  limit: number;
}

export default ( findQuery: (input: paramInputProps ) => Promise<paramProps> ) => {
  
  const [data, setData] = useState<Record<string, unknown>[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [loading, setLoading] = useState(false);

  const fetch = async (input?: { offset?: number; limit?: number }) => {
    let data;
    try {
      setLoading(true);
      data = await findQuery({ offset: input?.offset ?? first, limit: input?.limit ?? rows });
    } finally {
      setLoading(false);
    }

    setData(data.result);
    setTotalRecords(data.total);

    setFirst(input?.offset ?? first);
    setRows(input?.limit ?? rows);
  };

  const onPage = async (event: DataTablePFSEvent) => fetch({ offset: event.first, limit: event.rows });

  useEffect(() => {
    const run = async () => {
      await fetch();
    };

    run();
  }, []);

  return {
    fetch,
    tableProps: {
      first,
      lazy: true,
      onPage,
      paginator: true,
      rows,
      totalRecords,
      value: data
    }
  };
};
